// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__daaOl","dark":"styles_dark__ubhyp","btn":"styles_btn__nKdVc","green":"styles_green__DJVtj"};